import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { User } from '../user/user.service';

export interface Establecimiento {
  id: number,
  nombre: string,
  productor: User,
  localidadCercana: string,
  provincia?: string,
  latitud: string,
  longitud: string,
  userId: number,
  lotes: Array<Lote>,
  user: User,
}
export interface Lote {
  id:number,
  fechaSiembra: string,
  numeroLote: string,
  hectareas:number,
  insumo:string,
  variedad?: string,
  cantidadInsumo:number,
  tipoCultivo: string,
  estado: string,
  fechaAprobacion?: string,
  facturaFileUrl?: string,
  facturaFileName?: string,
  check?: boolean
  superficieAfectada?:number;
  establecimiento: Establecimiento,
  checked?:boolean,
  hidden?: boolean
  createdAt?: string;
  updatedAt?: string;

}
@Injectable({
  providedIn: 'root'
})
export class CoverageService {

  url = `${environment.api}/plansiembra`;

  constructor(public http: HttpClient) { }

  create(data: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.url, data, { observe: 'response' });
  }
  importarPlanesSiembra(data: any): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.url + '/importarPlanesSiembra', data, { observe: 'response' });
  }
  uploadFactura(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('facturaFile', file);
    return this.http.post(`${this.url}/uploadFactura`, formData);
  }

  update(data: any): Observable<any> {
    return this.http.put(`${this.url}/${data.id}`, data);
  }

  find(id: number): Observable<any> {
    return this.http.get(this.url + '/getById/'+ id);
  }

  updateState(data: any, idEstablecimiento: number): Observable<any> {
    return this.http.put(`${this.url}/${idEstablecimiento}/changeLoteStatus`, data);
  }

  search(filter: any, pageSize: number, paginaActual: number, empresa: any, usuarioZona: any, distribuidor: any, productor: any): Observable<any> {
    let state = filter.state?.length
        ? filter.state.map((e: any) => e.id)
        : [];
    let params = '?_sort=createdAt&_order=desc';
    if(state && state.length) params= params + `&status=${state.join(',')}`;
    if(filter.usuario) params+= `&usuario=${filter.usuario}`;
    if(filter.usuarioPadre) params+= `&usuarioPadre=${filter.usuarioPadre}`;
    if(filter.email) params+= `&email=${encodeURIComponent(filter.email.trim())}`;
    if(filter.cuit) params+= `&cuit=${encodeURIComponent(filter.cuit.trim())}`;
    if(empresa && empresa.length) params= params + `&empresa=${empresa.join(',')}`;
    if(usuarioZona && usuarioZona.length) params= params + `&usuarioZona=${usuarioZona.join(',')}`;
    if(distribuidor && distribuidor.length) params= params + `&distribuidor=${distribuidor.join(',')}`;
    if(productor && productor.length) params= params + `&productor=${productor.join(',')}`;

    params +=`&registros=${pageSize}`;
    params = params +`&paginaActual=${paginaActual}`;
    return this.http.get(this.url + params)
  }

  searchEstablecimientos(filter: any, pageSize: number, paginaActual: number, empresa: any, usuarioZona: any, distribuidor: any, productor: any): Observable<any> {
    let params = '?_sort=id&_order=desc';
    if(filter.usuario) params+= `&usuario=${filter.usuario}`;
    if(filter.usuarioPadre) params+= `&usuarioPadre=${filter.usuarioPadre}`;
    if(empresa) params= params + `&empresa=${empresa}`;
    if(distribuidor) params= params + `&distribuidor=${distribuidor}`;
    if(productor) params= params + `&productor=${productor}`;
    if(usuarioZona) params= params + `&usuarioZona=${usuarioZona}`;

    params +=`&registros=${pageSize}`;
    params = params +`&paginaActual=${paginaActual}`;
    return this.http.get(this.url+'/establecimientos' + params)
  }

  remove(id: any): Observable<any> {
    return this.http.delete(`${this.url}/${id}`)
  }
  removeMultiple(ids:number[]): Observable<any>{
    return this.http.post<any>(`${this.url}/deleteMultiple`, {ids:ids}, { observe: 'response' });
  }

  copiarPlanes(idCampania: number, idProductor?:number): Observable<any> {
    return this.http.put(`${this.url}/copiarPlanes/${idCampania}/${idProductor}`,{});

  }
  aprobarMultiple(ids:number[]): Observable<any>{
    return this.http.put<any>(`${this.url}/aprobarMultiple`, {ids:ids}, { observe: 'response' });
  }

  getAllDashboard(agent: any): Observable<any> {
    let params = "";
    if(agent.empresa) params = `&empresa=${agent.empresa}`;
    if(agent.distribuidor) params = `&distribuidor=${agent.distribuidor}`;
    if(agent.productor) params = `&agricultor=${agent.productor}`;
    return this.http.get(`${this.url}/getLotesPorEstablecimiento?_sort=id&_order=desc${params}`)
  }

  getReporteInsumosObjetivo(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;

    return this.http.get(`${this.url}/getReporteInsumosObjetivo?${params}`)
  }
  getReporteInsumosUtilizados(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteInsumosUtilizados?${params}`)
  }

  getReporteInsumosPorCampania(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteInsumosPorCampania?${params}`)
  }

  getReporteProductoresActivos(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteProductoresActivos?${params}`)
  }

  getReporteHectareasAfectadasPorCampania(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteHectareasAfectadasPorCampania?${params}`)
  }

  getReporteHectareasPorCampania(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteHectareasPorCampania?${params}`)
  }

  getReporteHectareasPorProvincia(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteHectareasPorProvincia?${params}`)
  }

  getReporteEstadosPlanesSiembra(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteEstadosPlanesSiembra?${params}`)
  }

  getReporteEstadosSolicitudes(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteEstadosSolicitudes?${params}`)
  }

  getReporteSiniestrosPorEstadoYEvento(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteSiniestrosPorEstadoYEvento?${params}`)
  }

  getReporteSiniestrosPorProvincia(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteSiniestrosPorProvincia?${params}`)
  }

  getReporteHectareasAfectadasPorEvento(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteHectareasAfectadasPorEvento?${params}`)
  }

  getReporteHectareasAfectadasPorEstado(filter: any): Observable<any> {
    let params = "";
    if (filter.empresa?.length)
      params += `&empresa=${filter.empresa.join(',')}`;
    if (filter.usuarioZona?.length)
      params += `&usuarioZona=${filter.usuarioZona.join(',')}`;
    if (filter.distribuidor?.length)
      params += `&distribuidor=${filter.distribuidor.join(',')}`;
    if (filter.productor?.length)
      params += `&agricultor=${filter.productor.join(',')}`;
    if(filter.insumo) params = params+`&insumo=${filter.insumo}`;
    if (filter.cultivo?.length)
      params += `&cultivo=${filter.cultivo.join(',')}`;
    return this.http.get(`${this.url}/getReporteHectareasAfectadasPorEstado?${params}`)
  }

}
